import React from "react";

const UserReportsComponent = (props) => <div>{props.data}</div>;
export default UserReportsComponent;
